/* tslint:disable */
/* eslint-disable */
/**
 * Telematics API
 * Telematics services API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MessageSeen
 */
export interface MessageSeen {
    /**
     * 
     * @type {string}
     * @memberof MessageSeen
     */
    user: string;
    /**
     * 
     * @type {Date}
     * @memberof MessageSeen
     */
    date: Date;
}

export function MessageSeenFromJSON(json: any): MessageSeen {
    return MessageSeenFromJSONTyped(json, false);
}

export function MessageSeenFromJSONTyped(json: any, ignoreDiscriminator: boolean): MessageSeen {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': json['user'],
        'date': (new Date(json['date'])),
    };
}

export function MessageSeenToJSON(value?: MessageSeen | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': value.user,
        'date': (value.date.toISOString()),
    };
}


